Object.defineProperty(exports, "__esModule", { value: true });
exports.globalResourceBundleName = 'GATSBY_THEME_LOCALIZATION_BUNDLE';
